import React, { useCallback } from "react";
import { NumericMappingValues, VirtualConfig } from "../type";
import { Button, Form, Input, InputNumber, Row, Space } from "antd";
import { ArrowRightOutlined, DeleteOutlined, PlusOutlined } from "@ant-design/icons";
import PlotFigure from "../../../UI/PlotFigure";
import { useDataset } from "./DatasetPicker";
import * as Plot from "@observablehq/plot";
import { indexToColor } from "../misc";

type NumericVirtualMappingDistributionProps = {
  value: VirtualConfig<NumericMappingValues>;
};
const NumericVirtualMappingDistribution: React.FC<NumericVirtualMappingDistributionProps> = ({ value }) => {
  const dataset = useDataset();
  const stats = dataset?.stats?.[0]?.["dist_" + value?.referToQuestionCode];
  const answerMap = dataset?.survey.answerMaps?.[value?.referToQuestionCode] || {
    ...Object.keys(stats ?? {}).reduce((acc, key) => {
      acc[key] = key;
      return acc;
    }, {}),
  };
  const statsNumericValue = Object.entries(answerMap ?? {}).map(([k, v]) => ({
    key: v,
    key_as_numeric: parseInt(k),
    value: stats?.[k],
  }));
  return (
    <div>
      <PlotFigure
        fit
        options={{
          marks: [
            Plot.barY(
              Object.keys(stats ?? {}).map((key) => {
                const statNumericValue = statsNumericValue.find((v) => v.key === key);
                const categoryForThisBar = value.categories?.find((c) => {
                  const { from, to } = c;
                  if (!statNumericValue) return false;
                  if (from && statNumericValue.key_as_numeric < from) return false;
                  if (to && statNumericValue.key_as_numeric >= to) return false;
                  return true;
                });
                const categoryIndex = categoryForThisBar ? value.categories.indexOf(categoryForThisBar) : -1;
                const barColor = categoryIndex === -1 ? "lightgrey" : indexToColor(categoryIndex);
                return {
                  key,
                  value: stats?.[key] ?? 0,
                  color: barColor,
                };
              }),
              {
                x: "key",
                y: "value",
                fill: "color",
              },
            ),
          ],
        }}
      />
    </div>
  );
};

export default NumericVirtualMappingDistribution;
